import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import routes from "./routes";

import { useController } from "./context";

export default function App() {
  const [controller] = useController();
  const { direction } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);


  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={<route.component />} key={route.key} />;
      }

      return null;
    });


  return (
    <>
      <CssBaseline />

      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={<Navigate to="/sitio/"/>} />
      </Routes>
    </>
  );
}
